import React, { useMemo, useState, useEffect } from "react"
import { useSelector } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import { useViewport } from 'components/general/useViewPort'
import { ALL_URL, getURL } from 'helpers/utils'
import { useNavigate, useParams } from 'react-router-dom';
import Moment from 'react-moment';
//import Table from 'react-bootstrap/Table'
import { useTable } from 'react-table'
import { Accordion } from 'react-bootstrap'
import { ColumnSession, ColumnTime, ColumnStatus, ColumnEvent, ColumnEventWithCompetitor, ColumnCompetitor, ColumnResult, ColumnLocation } from "components/common/schedule/TableColumns"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { getLevelRSC, getLongEventRSC } from "helpers/rsc"
import { ColumnSavesShotsColSpan } from "components/sports/wpo/components/TableColumns"
import Discipline from "components/presentation/Discipline"

const getConfiguration = (breakPoint, globalProps) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")

  let configuration = {
    columns: [],
    sortBy: []
  };
  configuration.sortBy = [{ id: 'Session', desc: false }]
  configuration.columns = isMobile ? TableColumnsSM(globalProps) : TableColumns(globalProps)
  return configuration;
};




const SessionScheduleTable = ({ data }) => {
  const { breakPoint } = useViewport();
  const globalProps = useSelector(getGlobalProps)
  const day = data[0]?.startDate
  const config = useMemo(() => getConfiguration(breakPoint, globalProps), [breakPoint, globalProps.timezone]);
  const sortedData = data.sort((a, b) => a?.session?.startDate - b?.session?.startDate)
  const [paramsUrl, setParamsUrl] = useState({});
  const [shouldNavigate, setShouldNavigate] = useState(false);
  useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'results')//useGetURL(paramsURL, 'results')

  //Prepare URL to navigate
  const params = useUrlFriendlyToParameters()
  let paramsURL = { ...params }
  const showDiscipline = paramsURL["mirs_discipline"] === ALL_URL.ALL_DISC
  const handleClick = (props) => {
    const rsc = props?.eventUnit?.code;

    if (getLevelRSC(paramsURL["mirs_rsc"]) === "EVENT") {
      paramsURL["mirs_event_rsc"] = rsc
      paramsURL["mirs_rsc"] = undefined
    } else {
      //Phase or unit
      paramsURL["mirs_event_rsc"] = getLongEventRSC(rsc)
      paramsURL["mirs_rsc"] = rsc
    }
    setParamsUrl(paramsURL);
    if (rsc.indexOf('TMRY') === -1) {
      setShouldNavigate(true);
    }
  };
  
  return (
    <Accordion className='schedule-container' defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header className='schedule-title'>

          {showDiscipline
            ? <Discipline code={data[0]?.discipline?.code} className={'img-fluid page-header-disciplina float-start w-5'} />
            : <Moment tz={globalProps.timezone} format="dddd Do MMMM">
              {day}
            </Moment>}
        </Accordion.Header>
        <Accordion.Body className="p-0">
          <Table key={`table-session-date-${day}`} columns={config.columns} data={sortedData} rowClickHandler={handleClick} />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}

function Table({ columns, data, rowClickHandler }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })

  const isClickable = (props) => {
    return (props?.code.indexOf('TMRY') === -1);
  }

  var lastSession = ''
  return (
    <table {...getTableProps()} className="table-schedule table table-striped table-bordered">
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.filter(h => h.id !== 'Session').map((column, i) => (
              <th {...column.getHeaderProps()} className={column.headerClassName} key={`header-${i}`}>{column.render('Header')}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          const sessionCode = row.original?.session?.code
          const isGrouped = sessionCode !== lastSession
          if (isGrouped) {
            lastSession = sessionCode
          }
          return (
            <React.Fragment key={`rowgroup-${i}`}>
              {isGrouped &&
                <tr>
                  <td colSpan={row.cells.length - 1} className="schedule-session">
                    {row.cells.find(c => c.column.id === 'Session').render('Cell')}
                  </td>
                </tr>
              }
              <tr {...row.getRowProps()} onClick={() => rowClickHandler(row.original)} key={`row-${i}`} className={isClickable(row.original) ? 'clickable-row' : ''}>
                {row.cells.filter(c => c.column.id !== 'Session').map(cell => {
                  return <td {...cell.getCellProps()} className={cell.column.className} key={`cell-${i}-${cell.column.id}`}>{cell.render('Cell')}</td>
                })}
              </tr>
            </React.Fragment>
          )
        })}
      </tbody>
    </table>
  )
}

export default SessionScheduleTable;

function TableColumns(globalProps) {
  return (
    [
      ColumnSession(globalProps, { disableSort: true }),
      ColumnTime(globalProps, { disableSort: true }),
      ColumnEvent({ disableSort: true }),
      ColumnCompetitor({}),
      ColumnResult({}),
      ColumnStatus({}),
      ColumnLocation({ disableSort: true })
    ]
  )
}

function TableColumnsSM(globalProps) {
  return (
    [
      ColumnSession(globalProps, { disableSort: true }),
      ColumnTime(globalProps, { disableSort: true }),
      ColumnEventWithCompetitor({ disableSort: true })
    ]
  )
}


